"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledCardContentDescription = void 0;
const material_1 = require("@mui/material");
const styles_1 = require("@mui/material/styles");
exports.StyledCardContentDescription = (0, styles_1.styled)(material_1.Box)(({ theme }) => ({
    ...theme.typography.body2,
    color: theme.palette.text.secondary,
    overflow: "hidden",
    height: 80,
}));
//# sourceMappingURL=index.js.map